import { useState } from "react";
import { deleteUserAuth } from "@/services/auth";
import { t } from "i18next";
import { useAuthStore } from "@/store/auth.store";
import { useNavigate } from "@tanstack/react-router";

interface UseDeleteUserState {
  deleteUser: () => Promise<void>;
  result: boolean | null;
  loading: boolean;
  error: string | null;
}

export const useDeleteUser = (): UseDeleteUserState => {
  const { signOut } = useAuthStore.getState();
  const [result, setResult] = useState<boolean | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const deleteUser = async (): Promise<void> => {
    setLoading(true);
    setError(null);
    try {
      await deleteUserAuth();
      await signOut();
      setResult(true);
      await navigate({ to: "/" });
    } catch {
      setError(t("common.error"));
      setResult(false);
    } finally {
      setLoading(false);
    }
  };
  return { deleteUser, result, loading, error };
};
